import { useRef, useState } from "react"

import classes from './CopyText.module.css'
import BodySimpleModalV2 from "../common/modal/BodySimpleModalV2"

const CopyText = ({text, prefix}) => {
    const identifierRef = useRef(null)

    const [messageText, setMessageText] = useState('Copy to clipboard.')

    const copyTexthandler = () => {
        navigator.clipboard.writeText(identifierRef.current.innerText)

        setMessageText('Copied')
        setTimeout(() => {
            setMessageText('Copy to clipboard.')
        }, 600);
    }

    return <span className={classes.identifier}>
        <BodySimpleModalV2 normalEvent={true} messages={[messageText]}>
            <button onClick={copyTexthandler} className={[classes.copy_button]} >
                <i className="ti ti-copy"></i>      
            </button>
        </BodySimpleModalV2>
        <span>{!prefix ? '#' : <span className={classes.prefix}>{prefix}</span>}<span ref={identifierRef} style={{whiteSpace: 'nowrap'}}>{text}</span></span>         
    </span>
}

export default CopyText